;(function() {
  'use strict'

  angular.module('core.validators', [])
})()
